import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  createAppelOffreApi,
  deleteAppelOffreApi,
  fetchAppelOffre,
  fetchAppelsOffres,
  publishAppelOffreApi,
  updateAppelOffreApi,
} from "../services/appelsOffresService";

const APPELS_OFFRES_QUERY_KEY = ["appels-offres"];

export const useAppelsOffres = () =>
  useQuery({
    queryKey: APPELS_OFFRES_QUERY_KEY,
    queryFn: fetchAppelsOffres,
  });

export const useAppelOffre = (id, options = {}) =>
  useQuery({
    queryKey: [...APPELS_OFFRES_QUERY_KEY, id],
    queryFn: () => fetchAppelOffre(id),
    enabled: Boolean(id),
    ...options,
  });

export const useCreateAppelOffre = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createAppelOffreApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: APPELS_OFFRES_QUERY_KEY });
      toast.success("Appel d'offre bien ajouté", { autoClose: 3000 });
    },
    onError: (err) => {
      const msg = err?.message || "Appel d'offre non ajouté";
      toast.error(msg, { autoClose: 3000 });
    },
  });
};

export const useUpdateAppelOffre = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }) => updateAppelOffreApi(id, payload),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: APPELS_OFFRES_QUERY_KEY });
      if (variables?.id) {
        queryClient.invalidateQueries({
          queryKey: [...APPELS_OFFRES_QUERY_KEY, variables.id],
        });
      }
      toast.success("Appel d'offre bien modifié", { autoClose: 3000 });
    },
    onError: (err) => {
      const msg = err?.message || "Appel d'offre non modifié";
      toast.error(msg, { autoClose: 3000 });
    },
  });
};

export const usePublishAppelOffre = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => publishAppelOffreApi(id),
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: APPELS_OFFRES_QUERY_KEY });
      if (id) {
        queryClient.invalidateQueries({
          queryKey: [...APPELS_OFFRES_QUERY_KEY, id],
        });
      }
      toast.success("Appel d'offre bien validée", { autoClose: 3000 });
    },
    onError: (err) => {
      const msg = err?.message || "Appel d'offre non validée";
      toast.error(msg, { autoClose: 3000 });
    },
  });
};

export const useDeleteAppelOffre = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => deleteAppelOffreApi(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: APPELS_OFFRES_QUERY_KEY });
      toast.success("Appel d'offre supprimé avec succès", { autoClose: 3000 });
    },
    onError: (err) => {
      const msg =
        err?.message ||
        "Une erreur est survenue lors de la suppression de l'appel d'offre";
      toast.error(msg, { autoClose: 3000 });
    },
  });
};
